// extracted by mini-css-extract-plugin
export default {"App":"Builder_App__eIzqM","mainContainer":"Builder_mainContainer__xGz+y"};